// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Myhd","top":"styles_top__1LyWF","left":"styles_left__igpby","description":"styles_description__1IDVs"};